import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-mt-3" }
const _hoisted_2 = { class: "p-field p-col-6" }
const _hoisted_3 = { class: "p-float-label p-mb-2" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-col-6" }
const _hoisted_6 = { class: "p-float-label p-mb-2" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-mt-4 p-ml-4" }
const _hoisted_9 = { class: "p-field-radiobutton" }
const _hoisted_10 = /*#__PURE__*/_createVNode("label", { for: "SUM" }, "SUM", -1)
const _hoisted_11 = { class: "p-field-radiobutton" }
const _hoisted_12 = /*#__PURE__*/_createVNode("label", { for: "MAX" }, "MAX", -1)
const _hoisted_13 = { class: "p-field-radiobutton" }
const _hoisted_14 = /*#__PURE__*/_createVNode("label", { for: "MIN" }, "MIN", -1)
const _hoisted_15 = { class: "p-field-radiobutton" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", { for: "COUNT" }, "COUNT", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_VCodeMirror = _resolveComponent("VCodeMirror")
  const _component_RadioButton = _resolveComponent("RadioButton")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, [
          _createVNode(_component_InputText, {
            id: "name",
            class: ["kn-material-input", {
                        'p-invalid': _ctx.v$.selectedKpi.name.$invalid && _ctx.v$.selectedKpi.name.$dirty
                    }],
            type: "text",
            maxLength: "25",
            modelValue: _ctx.v$.selectedKpi.name.$model,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.selectedKpi.name.$model = $event)),
            modelModifiers: { trim: true },
            onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.selectedKpi.name.$touch()))
          }, null, 8, ["modelValue", "class"]),
          _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
        ]),
        _createVNode(_component_KnValidationMessages, {
          vComp: _ctx.v$.selectedKpi.name,
          additionalTranslateParams: {
                    fieldName: _ctx.$t('common.name')
                }
        }, null, 8, ["vComp", "additionalTranslateParams"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_InputText, {
            id: "name",
            class: "kn-material-input",
            type: "text",
            modelValue: _ctx.selectedKpi.author,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedKpi.author = $event)),
            modelModifiers: { trim: true },
            disabled: true
          }, null, 8, ["modelValue"]),
          _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.author')), 1)
        ])
      ])
    ]),
    (!_ctx.loading)
      ? (_openBlock(), _createBlock(_component_VCodeMirror, {
          key: 0,
          ref: "codeMirror",
          class: "CodeMirrorMathematica",
          value: _ctx.selectedKpi.definition.formula,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedKpi.definition.formula = $event)),
          autoHeight: true,
          options: _ctx.codeMirrorOptions,
          onKeyup: _ctx.onKeyUp,
          onMousedown: _ctx.onMouseDown
        }, null, 8, ["value", "options", "onKeyup", "onMousedown"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      class: "kn-dialog--toolbar--primary importExportDialog",
      footer: "footer",
      visible: _ctx.functionDialogVisible,
      closable: false,
      modal: ""
    }, {
      header: _withCtx(() => [
        _createVNode("h4", null, _toDisplayString(_ctx.$t('kpi.kpiDefinition.formulaDialogHeader')) + " " + _toDisplayString(this.dialogHeaderInfo.functionName), 1)
      ]),
      footer: _withCtx(() => [
        _createVNode("div", null, [
          _createVNode(_component_Button, {
            class: "kn-button kn-button--secondary",
            label: _ctx.$t('common.apply'),
            onClick: _ctx.openFunctionPicker
          }, null, 8, ["label", "onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode(_component_RadioButton, {
              id: "SUM",
              name: "city",
              value: "SUM",
              modelValue: _ctx.selectedFunctionalities,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedFunctionalities = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_10
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_RadioButton, {
              id: "MAX",
              name: "city",
              value: "MAX",
              modelValue: _ctx.selectedFunctionalities,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedFunctionalities = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_12
          ]),
          _createVNode("div", _hoisted_13, [
            _createVNode(_component_RadioButton, {
              id: "MIN",
              name: "city",
              value: "MIN",
              modelValue: _ctx.selectedFunctionalities,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedFunctionalities = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_14
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode(_component_RadioButton, {
              id: "COUNT",
              name: "city",
              value: "COUNT",
              modelValue: _ctx.selectedFunctionalities,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectedFunctionalities = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_16
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}